// @ts-nocheck





import { fetchRequest } from './index';

export const addRepairOrder = async (
repairOrder) =>
{
  const added = await fetchRequest.post('/repairOrder', repairOrder);
  if (added) return added;
  throw new Error('Не удалось создать заявку');
};

export const updateRepairOrder = async (
repairOrder) =>
{
  const updated = await fetchRequest.put('/repairOrder', repairOrder);
  if (updated) return updated;
  throw new Error('Не удалось обновить заявку');
};

export const fetchRepairOrder = async (
id,
params = {}) =>
await fetchRequest.get(`/repairOrder/${id}`, params);

export const deleteRepairOrder = async (id) => {
  const deleted = await fetchRequest.delete(`/repairOrder/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить заявку');
};

export default {
  addRepairOrder,
  fetchRepairOrder,
  updateRepairOrder,
  deleteRepairOrder
};
